export var trackingPageNameConfig = {
    '/search-v2': 'SEARCH_PAGE',
    '/dashboard': 'DASHBOARD',
    '/auth/dream-destination': 'DREAM_DESTINATION'
};
var getTrackingPageName = function (pathname, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var trackingPageName = Object.keys(trackingPageNameConfig).find(function (key) { return pathname.includes(key); });
    return trackingPageName
        ? trackingPageNameConfig[trackingPageName] +
            (suffix ? "_".concat(suffix) : '')
        : pathname;
};
export default getTrackingPageName;
